<template>
  <div class="audit-popup">
    <div class="default-modal">
      <el-dialog v-model="AuditLogsPopup" class="existed-caseinfo-dialog">
        <div class="dialog-header">
          <span class="header-part"> Patient History </span>
          <el-button
            size="medium"
            class="el-white"
            type="info"
            plain
            @click="close"
          >
            <img src="@/assets/images/icons/cases/close-btn.svg" alt="icon"
          /></el-button>
        </div>
        <div class="all-cases-view">
          <div class="popup-date">
            <div class="primary-content-view-new" v-loading="loading">
              <div
                class="listings listings__table listings__all-cases"
                id="all-cases-listings"
                v-if="
                  this.getPatientHistory &&
                  this.getPatientHistory.data &&
                  this.getPatientHistory.data.length
                "
              >
                <el-table :data="getPatientHistory.data">
                  <el-table-column label="ACCESSION ID" width="150">
                    <template #default="scope">
                      <span class="patient-accession-id">{{
                        scope.row.accession_id
                      }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="DATE OF SERVICE" width="180">
                    <template #default="scope">
                      <div v-if="scope.row.collection_date" class="d-flex">
                        <div class="date pr-10">
                          {{
                            momentWithTimezone(
                              scope.row.collection_date,
                              "MM-DD-yyyy "
                            )
                          }}

                          <span style="color: royalblue; padding-left: 3px">
                            {{
                              momentWithTimezone(
                                scope.row.collection_date,
                                "hh:mm A"
                              )
                            }}
                          </span>
                        </div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="Case Type"
                    prop="case_types"
                    width="180"
                  >
                    <template #default="scope">
                      <div
                        class="case-type"
                        v-if="
                          scope.row.case_types &&
                          scope.row.case_types.length > 1
                        "
                      >
                        <el-dropdown>
                          <span class="case-data-type">
                            {{ getCaseTypes(scope.row.case_types)[0] }}

                            <img
                              src="@/assets/images/case-type-arrow.svg"
                              alt="icon"
                            />
                          </span>

                          <template #dropdown>
                            <el-dropdown-menu class="case-type-dropdown">
                              <el-dropdown-item
                                class="cases-view"
                                v-for="(caseType, index) of getCaseTypes(
                                  scope.row.case_types
                                )"
                                :key="index"
                              >
                                {{ caseType }}
                              </el-dropdown-item>
                            </el-dropdown-menu>
                          </template>
                        </el-dropdown>
                      </div>
                      <div
                        v-else-if="
                          scope.row.case_types &&
                          scope.row.case_types.length == 1
                        "
                        class="case-type"
                      >
                        <span class="case-data-type">
                          {{ getCaseTypes(scope.row.case_types)[0] }}
                        </span>
                      </div>
                      <div v-else></div>
                    </template>
                  </el-table-column>
                  <el-table-column label="INSURANCE" width="250">
                    <template #default="scope">
                      <div
                        v-if="
                          scope.row &&
                          scope.row.insurance_eligibility_verified_details &&
                          scope.row.insurance_eligibility_verified_details
                            .foundCoverages &&
                          scope.row.insurance_eligibility_verified_details
                            .foundCoverages.length
                        "
                      >
                        <div
                          v-for="coverage in scope.row
                            .insurance_eligibility_verified_details
                            .foundCoverages"
                          :key="coverage.id"
                        >
                          {{ coverage.payerName ? coverage.payerName : "--" }}
                        </div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="BILLING STATUS" width="180">
                    <template #default="scope">{{
                      scope.row.billing_status ? scope.row.billing_status : "--"
                    }}</template>
                  </el-table-column>
                  <el-table-column label="POLICY ID" width="170">
                    <template #default="scope">
                      <span
                        v-if="
                          scope.row &&
                          scope.row.billing_info &&
                          scope.row.billing_info.insurance &&
                          scope.row.billing_info.insurance.primary_insurance
                        "
                      >
                        {{
                          scope.row.billing_info.insurance.primary_insurance
                            ? scope.row.billing_info.insurance.primary_insurance
                                .policy_id
                            : "--"
                        }}
                      </span></template
                    >
                  </el-table-column>
                </el-table>
              </div>
              <div v-else class="insurance-pop-no-data">
                <span class="no-data-para"> No Insurance History Found </span>
              </div>
            </div>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import caseConstants from "@/config/constants/caseConstants";
export default {
  props: ["patientId"],
  data() {
    return {
      AuditLogsPopup: true,
      loading: false,
      page: 1,
      pageSize: 25,
      caseTypeMap: caseConstants.CASE_TYPE_MAP,
    };
  },
  async mounted() {
    await this.fetchPatientHistory();
  },
  computed: {
    ...mapGetters("cases", ["getPatientHistory", "getCaseInformation"]),
    getCaseTypes() {
      return (caseTypes) => {
        return (caseTypes || []).map((e) => this.caseTypeMap[e]);
      };
    },
  },
  methods: {
    async fetchPatientHistory() {
      try {
        this.loading = true;
        let case_id = this.getCaseInformation && this.getCaseInformation._id;
        await this.$store.dispatch("cases/fetchInsuranceHistory", case_id);
        this.loading = false;
      } catch (err) {
        this.loading = false;
        console.log(err);
      } finally {
        this.loading = false;
      }
    },
    close() {
      this.$emit("close", false);
    },
  },
};
</script>
<style lang="scss">
.audit-popup {
  .default-modal {
    .listings__table .el-table table tbody tr:nth-child(odd) {
      background-color: #f2f2f2;
    }
    .listings__table .el-table table tbody td.el-table__cell {
      border: none !important;
    }
    .el-dialog {
      width: 75%;
      @media (min-width: 1700px) and (max-width: 2500px) {
        width: 60%;
      }
    }
  }
}
.insurance-pop-no-data {
  width: 100%;
  text-align: center;
  .no-data-para {
    color: #f24a55;
  }
}
.patient-accession-id {
  padding: 5px;
  background: transparent;
  border: none;
  color: #eb5757;
  &:hover,
  &:focus {
    color: #eb5757;
    background: transparent;
  }
}
</style>
